import React from "react";
import Footer from "../components/utils/Footer";
import Carousel from "../components/carousel/Carousel";
import heatTransfersList from "../components/carousel/heatTransfersList";
import ServiceDescription from "../components/utils/ServiceDescription";
import CallToAction from "../components/utils/CallToAction";
import PhotoGrid from "../components/utils/PhotoGrid";
import Faq from "../components/faq/Faq";
import heatTransferFaq from "../components/faq/heatTransferFaq";
import NavBar from "../components/utils/NavBar";

const HeatPress = () => {
  return (
    <div className="bg-black">
      <div className="h-[calc(100dvh)] w-screen antialiased overscroll-contain overflow-x-hidden ">
        <NavBar />{" "}
        <ServiceDescription
          title={"HEAT TRANSFERS"}
          content={`Heat transfer provides unparalleled versatility for applying contemporary designs to clothing, allowing you to express your distinctive style. Whether it's custom twill, 3D patches, or even delicate fabrics, transfers offer the flexibility to give your attire that unique edge, helping you achieve the look you desire.`}
        />
        <Carousel
          CarouselTitle={"What We Can Do For You."}
          breakPoint={"  lg:justify-center"}
          CarouselCardList={heatTransfersList}
        />
        <PhotoGrid />
        <CallToAction />
        <Faq questionsList={heatTransferFaq} />
        <Footer />
      </div>
    </div>
  );
};

export default HeatPress;
